// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  margin: 8px !important;
  margin-bottom: 24px !important;
}
ion-card ion-card-header {
  border-bottom: 1px solid var(--ion-color-light);
  padding: 21px !important;
  display: flex !important;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}
ion-card ion-card-header ion-icon {
  font-size: 20px;
}
ion-card ion-card-header p {
  font-size: 16px;
  font-weight: 500;
  color: black;
}
ion-card ion-card-content {
  padding-top: 0 !important;
}
ion-card ion-card-content ion-item {
  --padding-start: 0;
}
ion-card ion-card-content ion-item .payment-type-icon {
  font-size: 32px;
}
ion-card ion-card-content ion-item ion-label {
  font-weight: normal;
  padding: 0 !important;
}
ion-card ion-card-content ion-item ul {
  list-style: none;
  padding: 0;
  margin: 0;
  color: var(--ion-color-medium);
}
ion-card ion-card-content ion-item ul li {
  font-size: 13px;
}
ion-card ion-card-content ion-item .button-has-icon-only {
  --padding-end: 0px;
  --padding-start: 0px;
  width: 40px;
  min-width: 40px;
  height: 40px;
  min-height: 40px;
}
ion-card ion-card-content ion-item .button-has-icon-only ion-icon {
  font-size: 18px;
}

.options {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.options ion-card {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid #ebeff8;
  border-radius: 12px;
  text-align: center;
  margin: 8px !important;
  padding: 16px;
  cursor: pointer;
  height: 200px;
}
.options ion-card ion-icon {
  font-size: 70px;
  margin-bottom: 32px;
}
.options ion-card p {
  font-size: 15px;
  color: black;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0 16px;
}
.options ion-card p span {
  font-size: 15px;
  font-weight: 600;
}

.table-container {
  border-radius: 13px !important;
}

.payments-list ion-item {
  --padding-top: 8px !important;
  --padding-bottom: 8px !important;
}

@media (max-width: 767px) {
  ion-card {
    margin-bottom: 16px !important;
  }
}
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px 0;
  position: relative;
}

.divider:before,
.divider:after {
  content: "";
  flex: 1;
  height: 1px;
  background-color: #ccc;
  margin: 0 10px;
}

.divider-text {
  font-size: 14px;
  color: #666;
}

.padding-top {
  padding-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/ticket-details/ticket-details.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,8BAAA;AACJ;AACI;EACI,+CAAA;EACA,wBAAA;EACA,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AACR;AACQ;EACI,eAAA;AACZ;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,YAAA;AAAZ;AAII;EACI,yBAAA;AAFR;AAIQ;EACI,kBAAA;AAFZ;AAIY;EACI,eAAA;AAFhB;AAKY;EACI,mBAAA;EACA,qBAAA;AAHhB;AAMY;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;AAJhB;AAMgB;EACI,eAAA;AAJpB;AAQY;EACI,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AANhB;AAQgB;EACI,eAAA;AANpB;;AAaA;EACI,aAAA;EACA,qCAAA;AAVJ;AAYI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;AAVR;AAYQ;EACI,eAAA;EACA,mBAAA;AAVZ;AAaQ;EACI,eAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AAXZ;AAaY;EACI,eAAA;EACA,gBAAA;AAXhB;;AAiBA;EACI,8BAAA;AAdJ;;AAkBI;EACI,6BAAA;EACA,gCAAA;AAfR;;AAmBA;EACI;IACI,8BAAA;EAhBN;AACF;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AAlBJ;;AAuBE;;EAEE,WAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AApBJ;;AAuBE;EACE,eAAA;EACA,WAAA;AApBJ;;AAuBE;EACE,iBAAA;AApBJ","sourcesContent":["ion-card {\n    margin: 8px !important;\n    margin-bottom: 24px !important;\n\n    ion-card-header {\n        border-bottom: 1px solid var(--ion-color-light);\n        padding: 21px !important;\n        display: flex !important;\n        flex-direction: row;\n        align-items: center;\n        gap: 16px;\n\n        ion-icon {\n            font-size: 20px;\n        }\n\n        p {\n            font-size: 16px;\n            font-weight: 500;\n            color: black;\n        }\n    }\n\n    ion-card-content {\n        padding-top: 0 !important;\n\n        ion-item {\n            --padding-start: 0;\n\n            .payment-type-icon {\n                font-size: 32px;\n            }\n\n            ion-label {\n                font-weight: normal;\n                padding: 0 !important;\n            }\n\n            ul {\n                list-style: none;\n                padding: 0;\n                margin: 0;\n                color: var(--ion-color-medium);\n\n                li {\n                    font-size: 13px;\n                }\n            }\n\n            .button-has-icon-only {\n                --padding-end: 0px;\n                --padding-start: 0px;\n                width: 40px;\n                min-width: 40px;\n                height: 40px;\n                min-height: 40px;\n\n                ion-icon {\n                    font-size: 18px;\n                }\n            }\n        }\n    }\n}\n\n.options {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n\n    ion-card {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        border: 1px solid #ebeff8;\n        border-radius: 12px;\n        text-align: center;\n        margin: 8px !important;\n        padding: 16px;\n        cursor: pointer;\n        height: 200px;\n\n        ion-icon {\n            font-size: 70px;\n            margin-bottom: 32px;\n        }\n\n        p {\n            font-size: 15px;\n            color: black;\n            font-weight: 600;\n            text-transform: uppercase;\n            margin: 0 16px;\n\n            span {\n                font-size: 15px;\n                font-weight: 600;\n            }\n        }\n    }\n}\n\n.table-container {\n    border-radius: 13px !important;\n}\n\n.payments-list {\n    ion-item {\n        --padding-top: 8px !important;\n        --padding-bottom: 8px !important;\n    }\n}\n\n@media (max-width: 767px) {\n    ion-card {\n        margin-bottom: 16px !important;\n    }\n}\n\n\n  .divider {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 5px 0; \n    position: relative;\n  }\n\n\n  \n  .divider:before,\n  .divider:after {\n    content: '';\n    flex: 1;\n    height: 1px;\n    background-color: #ccc; \n    margin: 0 10px; \n  }\n  \n  .divider-text {\n    font-size: 14px;\n    color: #666; \n  }\n\n  .padding-top {\n    padding-top: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
